module.exports = __webpack_public_path__ + "static/fx_6.454675d2.jpg";